module.exports = "/cyber/_next/static/images/winners-determination-bg-desktop-d944a135ac0cb8faabe820978a1f7bce.jpg";